import React, { useState, useEffect } from "react";
import { FormGroup, CustomInput } from "reactstrap";
import { setActiveCheckboxes } from "../../../actions/cases";
import { connect } from "react-redux";

export const CheckboxYourCases = (props) => {
  const [checked, setChecked] = useState(false);

  // on didmount check if there is an opened case and (if yes) flag it
  useEffect(() => {
    if (props.analysis.id === props.data.id) {
      setChecked(true);
      handleChange(props.data.id);
    }
  }, []);

  // any time there is a change on props.active_checkboxes check the flag
  useEffect(() => {
    if (props.active_checkboxes.includes(props.data.id)) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [props.active_checkboxes]);

  // function that handles the click
  const handleChange = (id) => {
    if (props.active_checkboxes.includes(id)) {
      props.setActiveCheckboxes(
        props.active_checkboxes.filter((elem) => elem !== id)
      );
    } else {
      props.setActiveCheckboxes([...props.active_checkboxes, id]);
    }
  };

  return (
    <React.Fragment>
      <FormGroup style={{ marginTop: "-2px" }}>
        <CustomInput
          className="checkboxYourCases"
          type="checkbox"
          id={props.data.id}
          checked={checked}
          onChange={() => handleChange(props.data.id)}
        />
      </FormGroup>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  analysis: state.analysis,
  active_checkboxes: state.cases.active_checkboxes,
});

export default connect(mapStateToProps, { setActiveCheckboxes })(
  CheckboxYourCases
);
